module.exports = __webpack_public_path__ + "static/img/android_qrCode.92f2185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/android_qrCode.png
// module id = mQlS
// module chunks = 23